(ns frontend.view.grid.tasks-grid.db
  (:require
   [frontend.db :as app-db]
   [frontend.state.current-session :as session]
   [reagent.core :as r]
   [clojure.string :as string]
   [common.util :as cu]
   [potpuri.core :refer [fn-> fn->>]]
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.utils :as fu]
   [common.email :as email]))

(defonce tasks (r/cursor app-db/views [:tasks-grid]))
(defonce modal-state (r/cursor tasks [:modals]))
(defonce grid-entities (r/cursor tasks [:grid-entities]))
(defonce webentry-task (r/cursor tasks [:webentry-task]))
(defonce view-settings (r/cursor tasks [:view-settings]))
(defonce task-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))
;;(defonce accounts (r/cursor db/session [:accounts]))
;;(defonce session-entities (r/cursor db/session [:entities]))
(defonce server-time (r/cursor app-db/session [:server-time]))

(defn display-associated
  [entity-type entity-ids]
  (if (empty? entity-ids)
    ""
    (->> entity-ids
         (map session/get-entity)
         (cu/only-entity entity-type)
         (map (fn [e]
                (entity/resolve-entity-name e session/get-entity session/reverse-lookup)))
         sort
         (string/join ", "))))

(defn get-tasks-display-data
  [data]
  (merge
   data
   (when (= (:task/type data) :task.type/email)
     {:task/message (loc/tr :resolve-email)})
   (when (= (:task/type data) :task.type/webentry)
     {:task/message (loc/tr :resolve-deal-entry-task-title)})
   {:task/completed?
    (-> data
        :task/completed?
        boolean)                ;;nil as an explicit false
    :task/due
    (some->> data
             :task/due
             (fu/display-date-timestamp))
    :common/created-on
    (some->> data
             :common/created-on
             (fu/display-date-timestamp))
    :task/assignee
    (some->> data
             :task/assignee
             (session/get-entity)
             (entity/display-string))
    :common/related-entities-oppo
    (some->> data
             :common/related-entities
             (display-associated :entity.type/oppo))
    :common/related-entities-company
    (some->> data
             :common/related-entities
             (display-associated :entity.type/company))
    :common/related-entities-real-estate
    (some->> data
             :common/related-entities
             (display-associated :entity.type/real-estate))
    :common/related-entities-fof-asset
    (some->> data
             :common/related-entities
             (display-associated :entity.type/fof-asset))
    :common/related-entities-other-asset
    (some->> data
             :common/related-entities
             (display-associated :entity.type/other-asset))
    :common/related-entities-person
    (some->> data
             :common/related-entities
             (display-associated :entity.type/person))
    :common/related-entities-fund-commitment
    (some->> data
             :common/related-entities
             (display-associated :entity.type/fund-commitment))
    :common/related-entities-holdings
    (some->> data
             :common/related-entities
             (display-associated :entity.type/holding))
    :common/related-entities-sale-agreements
    (some->> data
             :common/related-entities
             (display-associated :entity.type/sale-agreement))
    :common/related-entities-investor
    (some->> data
             :common/related-entities
             (display-associated :entity.type/investor))
    :common/related-entities-fundraising-opportunities
    (some->> data
             :common/related-entities
             (display-associated :entity.type/fundraising-opportunity))
    :common/related-entities-sales-opportunities
    (some->> data
             :common/related-entities
             (display-associated :entity.type/sales-opportunity))
    :common/related-entities-exit-opportunities
    (some->> data
             :common/related-entities
             (display-associated :entity.type/exit-opportunity))
    :common/related-entities-fund
    (some->> data
             :common/related-entities
             (display-associated :entity.type/fund))
    :fund-commitment/cur-committed-amount
    (some->> data
             :fund-commitment/cur-committed-amount
             (fu/bigdec->float))}))
